<template>
  <div class="page">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="titel">
          <img
            src="https://img.alicdn.com/imgextra/i2/O1CN01RA2hkf1jpTPJBdxmZ_!!6000000004597-55-tps-30-30.svg"
          />
          <div style="margin-left: 10px;">模式介绍</div>
        </div>
      </div>
      <div class="card-body">
        <div class="text">
          智联云油自建的供应链资源，为加油站提供积分兑换商品及供应链服务。通过平台提供全量的商品能力。赋能加油站搭建积分商城体系，有效的解决了加油站积分商城中的品类不足和库存，压货，售后等问题。
        </div>
        <div
          class="image"
          style="
            background-image: url('https://img.alicdn.com/imgextra/i4/O1CN01NDXYWh286SsWMnexH_!!6000000007883-55-tps-1061-235.svg');
          "
        ></div>
      </div>
    </el-card>
    <div class="bottom">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <div class="titel">
            <img
              src="https://img.alicdn.com/imgextra/i4/O1CN01EYxyHl1qTfrembKIA_!!6000000005497-55-tps-30-30.svg"
            />
            <div style="margin-left: 10px;">方案优势</div>
          </div>
        </div>
        <div class="card-body">
          <div
            class="image"
            style="
              background-image: url('https://img.alicdn.com/imgextra/i4/O1CN01xOZnqa21dFvNGcYEM_!!6000000007007-55-tps-646-174.svg');
            "
          ></div>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-left: 24px;">
        <div slot="header" class="clearfix">
          <div class="titel">
            <img
              src="	https://img.alicdn.com/imgextra/i4/O1CN01pfRhRY27nEFAEGLXn_!!6000000007841-55-tps-30-30.svg"
            />
            <div style="margin-left: 10px;">动态公告</div>
          </div>
        </div>
        <div class="card-body"></div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'checkgoods.vue',
}
</script>

<style scoped>
.text {
  font-size: 16px;
  font-weight: 400;
  color: #999;
}

.item {
  margin-bottom: 18px;
}
.titel {
  display: flex;
  align-items: center;
  font-size: 20px;
  /*margin-left: 10px;*/
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
  margin: 0 0 24px;
}
.bottom {
  display: flex;
}
.box-card1 {
  width: 777px;
}
.box-card2 {
  width: 777px;
  margin-left: 24px;
}
.card .card-body {
  padding: 24px;
}
.page {
  width: 100%;
  height: 100%;
  overflow: auto;
  /*padding: 20px 25px;*/
  padding: 20px 0;
  padding-left: 10px;
  padding-right: 50px;
}
::v-deep.el-card__header {
  padding: 15px 20px;
}
.image {
  width: 100%;
  height: 235px;
  margin: 24px 0;
  background-position: 50%;
  background-repeat: no-repeat;
}
</style>
